var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"left-side-menu"},[_c('SideNav',{attrs:{"is-condensed":_vm.isCondensed}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }